module.exports = __webpack_public_path__ + "img/descImg8.820719a8.png";